// Port of api/fuel/app/classes/insights/collection/years.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'years',
    insight: ['year'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        // set the limit
        var limit = detail ? 100000 : 25

        var year_type = (filter.year !== undefined) ? filter.year : 'version'

        var years = {}

        var currentYear = new Date().getUTCFullYear()

        for (var i = currentYear; i > currentYear - limit; i--) {
            years[i] = {
                year: i,
                count: 0
            }
        }

        var collectionIndex = Util.queryFast('\
            SELECT \
                g.game_published AS gy, \
                v.game_version_year AS vy \
            FROM \
                ( \
                    collection c \
                    JOIN \
                    game g \
                    ON \
                    c.game_id = g.game_id \
                ) \
                LEFT JOIN \
                game_version v \
                ON \
                c.game_version_id = v.game_version_id \
            WHERE \
                c.user_id IN (' + Util.in(userIndex) + ') \
                AND \
                c.collection_own = 1 \
                AND \
                g.game_type = 1 \
            GROUP BY \
                g.game_id, \
                v.game_version_id \
        ')

        var earliestYear = detail ? currentYear : currentYear - limit

        for (var ci = 0; ci < collectionIndex.length; ci++) {
            var item = collectionIndex[ci]

            var year = (item.vy && year_type === 'version') ? parseInt(item.vy, 10) : parseInt(item.gy, 10)

            if (years[year] !== undefined) {
                years[year].count++
            }

            if (earliestYear > year && (!detail || (detail && year > currentYear - limit))) {
                earliestYear = year
            }
        }

        var yearsArray = Util.sort_by_field(Object.keys(years).map(function(k) { return years[k] }), 'year', 'desc')

        yearsArray = yearsArray.filter(function(y) {
            return y.year >= earliestYear && (y.count > 0 || y.year > (currentYear - 25))
        })

        return {
            years: yearsArray,
            moreYears: (!detail && earliestYear < currentYear - limit) ? true : false
        }

    }
})
